import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useFeatureFlags, { FeatureFlags } from '../../hooks/useFeatureFlags'
import ViewLoadingFallback from '../../components/ViewLoadingFallback'

const ApprovalsIndexRedirect = () => {
  const isUserLoggedIn = useSelector(state => state.auth.isUserLoggedIn)
  const { isEnabled, isLoading } = useFeatureFlags()

  if (!isUserLoggedIn || isLoading) return <ViewLoadingFallback />

  const target = isEnabled(FeatureFlags.ENABLE_PROJECT_OVERVIEW_TAB)
    ? 'project-overview'
    : 'approvals'

  return <Navigate to={target} replace />
}

export default ApprovalsIndexRedirect
